var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"title-class my-auto ma-0 pa-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }